import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-privacy-statements',
  templateUrl: './privacy-statements.component.html',
  styleUrls: ['./privacy-statements.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrivacyStatementsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
